import { Box, Spinner, theme } from '@everlywell/ui-kit';
import React from 'react';

export type CartSpinnerProps = {};

/**
 * Spinner displayed when the cart is loading.
 */
function CartSpinner(props: CartSpinnerProps): JSX.Element {
  return (
    <Box
      position={'absolute'}
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={theme.zIndices.overlay}
      background="tints.white"
      opacity={0.5}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Spinner />
    </Box>
  );
}

export default CartSpinner;
